var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar sidebarStyle",attrs:{"data-color":_vm.activeColor}},[_c('div',{staticClass:"sidebar-wrapper"},[_vm._t("content"),_c('md-list',{staticClass:"nav"},[_vm._t("default",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-link',{key:link.name + index,attrs:{"to":link.path,"link":link}})}))],2)],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c91da0d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarPlugin/SideBar.vue
// module id = null
// module chunks = 